const ROUTES = {
    INTRO: '/',
    STORY: '/story',
    CHECKOUT: '/checkout'
}

export default ROUTES;